import React from 'react';
import {
  AbstractButton,
  Box,
  Card,
  Flex,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from 'pounceV2';
import useEventHandler from 'Hooks/useEventHandler';
import useFastField from 'Hooks/useFastField';
import { useTheme } from '@mui/material';

type SimpleSelectChipFieldProps = {
  name: string;
  items: string[];
  disabled: boolean;
};
const SimpleSelectChipFieldV3: React.FC<SimpleSelectChipFieldProps> = ({
  name,
  items,
  disabled,
}) => {
  const {
    palette: { componentTokens },
  } = useTheme();
  const [field, , { setValue }] = useFastField(name);
  const handleChange = useEventHandler(e => setValue(e));

  return (
    <Popover>
      {({ close: closePopover }) => (
        <>
          <PopoverTrigger as={AbstractButton} aria-label="Toggle User Menu" disabled={disabled}>
            <Box
              backgroundColor={componentTokens.tags.colors.brand.background.resting}
              borderRadius="large"
              p={2}
            >
              <Flex justify="center" align="center" gap={2}>
                <Text variant="body/md">{field.value as string}</Text>
                <Icon type="caret-down" />
              </Flex>
            </Box>
          </PopoverTrigger>
          <PopoverContent alignment="bottom-right">
            <Card
              as="ul"
              minWidth={100}
              my={1}
              border={`1px solid ${componentTokens.selectMenuItems.color.item.stroke.container.resting}`}
              backgroundColor={componentTokens.selectMenuItems.color.item.background.containerBase}
            >
              {items.map(conjunction => (
                <Box
                  key={conjunction}
                  px={1.5}
                  py={3}
                  as="li"
                  cursor="pointer"
                  _hover={{
                    backgroundColor:
                      componentTokens.selectMenuItems.color.item.background.row.hover,
                  }}
                  onClick={() => {
                    handleChange(conjunction);
                    closePopover();
                  }}
                >
                  <Text>{conjunction}</Text>
                </Box>
              ))}
            </Card>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default React.memo(SimpleSelectChipFieldV3);
